import { CarrierLookup } from '@store/carriers/carrierLookup/types';
import { createAppStore } from '@store/createAppStore';
type storeType = {
  carrierLookup: CarrierLookup | null;
};
export const [carrierLookupStore, setCarrierLookupStore] =
  createAppStore<storeType>(
    {
      carrierLookup: null,
    },
    'carrierLookupStore',
  );
